import { getErrorTranslation } from './errorTranslations';

const getLocaleFromUrl = () => {
  if (typeof window !== 'undefined') {
    const pathSegments = window.location.pathname.split('/');
    const possibleLocale = pathSegments[1];
    if (['en', 'uk', 'de', 'ua'].includes(possibleLocale)) {
      return possibleLocale;
    }
  }
  return 'en';
};

export const getErrorMessage = (response: any) => {
  if (typeof response === 'string') {
    return response;
  }

  if (response?.code) {
    return getErrorTranslation(
      response.code,
      response.message,
      getLocaleFromUrl(),
      response.additionalInfo,
    );
  }

  const error =
    response?.statusText ||
    response?.message ||
    response?.errorText ||
    response?.errorMessage ||
    response?.errorMessages ||
    response?.messages;

  const errorArr = Array.isArray(error) ? error : [error];

  return errorArr.join(', ');
};
